<template>
    <el-submenu
            :popper-append-to-body="false"
            v-if="menu.list && menu.list.length >= 1"
            :index="menu.id+''"
    >
        <template slot="title">
            <span>{{ menu.name }}</span>
        </template>
        <voc-sub-menu
                v-for="item in menu.list"
                :key="item.id+''"
                :menu="item"
        >
        </voc-sub-menu>
    </el-submenu>
    <el-menu-item v-else :index="menu.id+''" @click="gotoRouteHandle(menu)">
        <!--<icon-svg :name="menu.icon || ''" class="site-sidebar__menu-icon"></icon-svg>-->
        <span>{{ menu.name }}</span>
    </el-menu-item>
</template>

<script>
    import VocSubMenu from './main-sidebar-sub-menu'

    export default {
        name: 'voc-sub-menu',
        props: {
            menu: {
                type: Object,
                required: true
            },
        },
        computed: {
            VOCTagsList: {
                get() {
                    return this.$store.state.VOCTagsList
                },
                set(val) {
                    this.$store.commit("updateVOCTagsList", val);
                }
            },
        },
        components: {
            VocSubMenu
        },
        methods: {
            // 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
            gotoRouteHandle(item) {

                // console.log(item)
                let self = this
                // debugger

                //  先判断是否是外部链接
                if (item.type === 3 && item.url) {
                    let urls = item.url
                    console.log(urls)
                    window.open(urls, '_blank')
                    return
                }




                // console.log(item)
                if (item.query) {
                    self.handleVOCTagsList(item)
                    self.$router.push({name: item.routerName, query: JSON.parse(item.query)})
                } else {
                    self.handleVOCTagsList(item)
                    self.$router.push({name: item.routerName})
                }
            },
            handleVOCTagsList(item) {
                // console.warn('=============================')
                // console.log(item)
                let List = JSON.parse(JSON.stringify(this.VOCTagsList)) || []
                // let List = this.VOCTagsList || []
                let isExist = false
                for (let i = 0; i < List.length; i++) {
                    if (List[i].routerName === item.routerName && List[i].query === item.query) {
                        isExist = true
                        break
                    }
                }

                if (!isExist) {
                    List.push(item)
                    this.VOCTagsList = List
                }


                // console.log(this.VOCTagsList)

            },
        }
    }
</script>
